import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ChartComponentBase } from '../chart.types';
import { ColumnDef } from 'tsui/lib/ts-table/ts-table.model';
import { FieldDef } from '@core/models/account.types';
import { removeArchivedFieldsFromTableDefinition } from '@shared/functions/fields-functions';

@Component({
  selector: 'chart-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartTableComponent extends ChartComponentBase {
  rowData: any[] = [];
  headers: string[] = [];
  columnDefs: ColumnDef[] = [];

  constructor() {
    super();
  }

  prepareChart(): void {
    const displayFields = removeArchivedFieldsFromTableDefinition(this.chartDef.display_fields, this.fields);
    this.columnDefs = displayFields.map((column) => {
      let colDef = this.lookupField(column);
      return {
        ...colDef,
        tsTableOptions: {
          headerName: colDef.label,
          // dots in the object key names will cause issues
          field: colDef.name.replace(/^related_to\./, 'related_to-'),
        },
        meta: {
          readonly: true,
        },
      };
    });

    this.rowData = Array.isArray(this.chartDef.data)
      ? this.chartDef.data
      : Object.keys(this.chartDef.data ?? {}).map((x) => this.chartDef.data[x]);
  }

  lookupField(name: string): FieldDef | undefined {
    return this.fields.find((fieldDef) => fieldDef.name === name);
  }
}
